import axios from 'axios'
import * as Util from '@/vuex/util'

let startState = []

const state = {
  districts: startState
}

const mutations = {
  FETCH (state) {
    axios.get(Util.makeApiUrl('/districts/city/all')).then(function (response) {
      state.districts = response.data
    }).catch(function (error) {
      console.log(error)
    })
  },

  RESET (state) {
    state.districts = startState
  }
}

const actions = {
  fetch: function ({commit}, filters) {
    commit('FETCH', filters)
  },

  reset: function ({commit}) {
    commit('RESET')
  }
}

const getters = {
  get: state => state.districts
}

export const CityCouncilDistrictsView = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/views/CityCouncilDistrictsView.js